(() => {
  const storageKey = 'primevo:pending_enquiry';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const emit = (name, details) => {
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try {
      const result = window.Shopify.analytics.publish(`primevo:${name}`, details);
      if (result?.catch) result.catch(() => {});
      return true;
    } catch { return false; }
  };
  const kind = form => form.id === 'ContactForm' ? 'quote' : form.matches('.pv-professional-form') ? 'partner_request' : null;
  const reportSuccess = () => {
    if (!allowed()) return;
    const success = document.querySelector('[data-pv-lead-success]');
    if (!success) return;
    try {
      const pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!pending || pending.kind !== success.dataset.pvLeadSuccess || Date.now() - pending.time > 1800000) return;
      if (emit(`${pending.kind}_submitted`, { form_type: pending.kind, language: document.documentElement.lang, page_path: location.pathname })) {
        sessionStorage.removeItem(storageKey);
      }
    } catch {}
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !allowed() || !form.checkValidity()) return;
    const formKind = kind(form);
    if (!formKind) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ kind: formKind, time: Date.now() })); } catch {}
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-pv-whatsapp]');
    if (link) emit('whatsapp_clicked', { language: document.documentElement.lang, page_path: location.pathname });
  });
  document.addEventListener('visitorConsentCollected', reportSuccess);
  window.addEventListener('pageshow', reportSuccess);
  reportSuccess();
})();
